export default __webpack_public_path__ + "static/media/matchmaker-radio-off.24964752.svg";